import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { useEffect, useState } from 'react';
import SkillCategoriesService from '../../../services/skillcategories-service';
import { SkillCategory } from '../../../../types';

export const useSkillCategories = (names?: string[]) => {
  const {
    data: skillCategories,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useQuery<SkillCategory[], AxiosError>({
    queryFn: () => SkillCategoriesService.list({ names } )
  });

  const [parsedSkillCategories, setParsedSkillCategories] = useState<SkillCategory[]>([]);

  useEffect(() => {
    if (isSuccess && skillCategories) {
        setParsedSkillCategories(skillCategories as SkillCategory[]);
    }
  }, [skillCategories, isSuccess]);

  return {
    skillCategories,
    parsedSkillCategories,
    isLoading,
    isSuccess,
    isError,
    error,
  };
};
